module.exports = __webpack_public_path__ + "static/media/doipassarinhos-partitura.5a2b176d.png";